export default function ErrorMessage({ touched, errors, className }) {
  return (
    touched &&
    errors && (
      <p className={`text-red-500 text-xs mt-1 ${className}`}>{errors}</p>
    )
  );
}
